import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import Classes, { IncomingFedWire, OutgoingFedWire } from "model";

/**
* @class FedWire
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.fedWires[0];
* const wire = new FedWire(record);
* @property {NUMBER} _id - The id of the FedWire
* @property {STRING} _type - The name of the FedWire
*
* @description - The primary class for the FedWire type.
* 
*/

export default class FedWire extends BCMSRecord {
  _id
  _type
  _wireDate 
  _amount 
  _status 
  _imad 
  _omad

  constructor(record) {
    super(record)
  }

  /**    
  * @property id {STRING} - Returns the fedWire for the appropriate type
  * @example const wire = FedWire.initByType("1");
  * @memberof FedWire 
  */
  static initByType(id) {
    let item = FedWire.initByID(id);

    switch(item.type) {
      case "outgoing":
        return OutgoingFedWire.initByID(id);
      case "incoming":
        return IncomingFedWire.initByID(id);
    }
  }

  /** 
  * @function initAll   
  * @static
  * @property {VOID} - No parameters
  * @description Returns all wires.
  * @example const wires = FedWire.initAll();
  * @memberof FedWire 
  */
  static initAll() {
    const wires = this._GlobalController.state[this._RecordType];

    return wires.map((record) => {
        return this.initByType(record.id);
    });
  }
  
}

FedWire.define({
  "recordType": "fedWires",
  "recordIDProp": "id",
  "className" : "FedWire",
  "recordProperties": [
   /** 
    * @name id
    * @instance
    * @property get {NUMBER} - gets the id of the wire
    * @property set {NUMBER} - sets the id of the wire
    * @memberof FedWire 
    */
    BCMSRecordProperty.mapToString("id", "_id"),

    /** 
     * @name name
     * @instance
     * @property get {STRING} - gets the name of the wire
     * @property set {STRING} - sets the name of the wire
     * @memberof FedWire 
     */
    BCMSRecordProperty.mapToString("type", "_type"),

    /** 
     * @name wireDate
     * @instance
     * @property get {BCMSDate} - gets the wire date
     * @property set {BCMSDate} - sets the wire date
     * @memberof FedWire 
     */
    BCMSRecordProperty.mapToDate("wireDate", "_wireDate"),

    /** 
     * @name amount
     * @instance
     * @property get {BCMSCurrency} - gets the wire amount
     * @property set {BCMSCurrency} - sets the wire amount
     * @memberof FedWire 
     */
    BCMSRecordProperty.mapToCurrency("amount", "_amount"),

    /** 
     * @name status
     * @instance
     * @property get {STRING} - gets the wire status
     * @property set {STRING} - sets the wire status
     * @memberof FedWire 
     */
    BCMSRecordProperty.mapToString("status", "_status"),

    /** 
     * @name imad
     * @instance
     * @property get {STRING} - gets the IMAD
     * @property set {STRING} - sets the IMAD
     * @memberof FedWire 
     */
    BCMSRecordProperty.mapToString("imad", "_imad"),

    /** 
     * @name omad
     * @instance
     * @property get {STRING} - gets the OMAD
     * @property set {STRING} - sets the OMAD
     * @memberof FedWire 
     */
    BCMSRecordProperty.mapToString("omad", "_omad"),
  ]
})
